import React, { useEffect, useState } from "react";
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb'
import AllAcountsSection from '../../Components/AllAccountsSection/AllAcountsSection'
import ContainsArea from '../../Components/ContainsArea/ContainsArea'
import SavePlusAccountComponent from '../../Components/SavePlusAccount/SavePlusAccountComponent'
import { AiFillCaretRight } from "react-icons/ai"
import AllAccounts from "../../Components/AllAccounts/AllAccounts";
import ContactForm from "../../Components/ContactForm/ContactForm";
import CustomerCare from "../../Components/CustomerCare/CustomerCare";
import OurStores from "../../Components/OurStories/OurStores";

const SalaryAccount = () => {
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Salary%20Acc.png";
  const percent = "https://izbassetsmain.blob.core.windows.net/izbwebassets/percentage.png";
  const CC = "https://izbassetsmain.blob.core.windows.net/izbwebassets/credit-card.png";
  const EmailAlert = "https://izbassetsmain.blob.core.windows.net/izbwebassets/alert.png";
  const money = "https://izbassetsmain.blob.core.windows.net/izbwebassets/money.png";
  const fee = "https://izbassetsmain.blob.core.windows.net/izbwebassets/money.png";
  const hospital = "https://izbassetsmain.blob.core.windows.net/izbwebassets/atm.png";
  const shield = "https://izbassetsmain.blob.core.windows.net/izbwebassets/credit-card.png";
  const loan = "https://izbassetsmain.blob.core.windows.net/izbwebassets/booking.png";
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/tonse-banner.png";

  const [activeTab, setActiveTab] = useState('benefits');

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const accountContent = "Indo Salary Account is a convenient interest-based account designed specifically for salaried employees, offering flexibility, financial benefits, and added insurance protection. It requires no minimum balance, making it easy to manage regardless of your income level. A monthly maintenance fee of K50.00 applies, and account holders receive SMS alerts to stay updated on their transactions.";

  return (
    <>
      <Breadcrumb Heading="Indo Salary Account" img={BackgroundBrundcrumb} show={true} btnTxt="Open an Account" />
      <SavePlusAccountComponent
        btnTxt="Open an Account"
        heading="Indo Salary Account"
        subHeading="Know More"
        content={accountContent}
        img={img1}
      />
      <ContainsArea />

      {/* Tabs Section */}
      <section className="container my-5">
        <div className="row">
          <div className="col-12">
            <ul className="nav nav-tabs" style={{ borderBottom: "2px solid #9E1B1E" }}>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'benefits' ? 'active' : ''}`} 
                  style={{ 
                    color: activeTab === 'benefits' ? '#9E1B1E' : '#484848',
                    fontWeight: activeTab === 'benefits' ? 'bold' : 'normal',
                    borderBottom: activeTab === 'benefits' ? '3px solid #9E1B1E' : 'none'
                  }}
                  onClick={() => setActiveTab('benefits')}
                >
                  Benefits
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'requirements' ? 'active' : ''}`} 
                  style={{ 
                    color: activeTab === 'requirements' ? '#9E1B1E' : '#484848',
                    fontWeight: activeTab === 'requirements' ? 'bold' : 'normal',
                    borderBottom: activeTab === 'requirements' ? '3px solid #9E1B1E' : 'none'
                  }}
                  onClick={() => setActiveTab('requirements')}
                >
                  Requirements
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'charges' ? 'active' : ''}`} 
                  style={{ 
                    color: activeTab === 'charges' ? '#9E1B1E' : '#484848',
                    fontWeight: activeTab === 'charges' ? 'bold' : 'normal',
                    borderBottom: activeTab === 'charges' ? '3px solid #9E1B1E' : 'none'
                  }}
                  onClick={() => setActiveTab('charges')}
                >
                  Service Charges
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Benefits Tab Content */}
        {activeTab === 'benefits' && (
          <section className="my-5">
            <div className="container">
              <div className="text-center my-5">
                <h1 style={{ color: "#484848" }}>
                  Our Indo Salary Account Benefits
                </h1>
              </div>
              <div className="row">
                <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                  <div className="text-center">
                    <img src={percent} alt="" width="60" />
                    <h5 className="mt-3" style={{ color: "#484848" }}>Tiered interest rates</h5>
                    <p style={{ color: "#949292" }}>4% - 6% per annum</p>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                  <div className="text-center">
                    <img src={CC} alt="" width="60" />
                    <h5 className="mt-3" style={{ color: "#484848" }}>Access to IZB Cards</h5>
                    <p style={{ color: "#949292" }}>Classic, Gold, or Platinum Visa Debit Cards</p>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                  <div className="text-center">
                    <img src={EmailAlert} alt="" width="60" />
                    <h5 className="mt-3" style={{ color: "#484848" }}>SMS Alerts</h5>
                    <p style={{ color: "#949292" }}>For all transactions</p>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                  <div className="text-center">
                    <img src={money} alt="" width="60" />
                    <h5 className="mt-3" style={{ color: "#484848" }}>No Minimum Balance</h5>
                    <p style={{ color: "#949292" }}>Requirement</p>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                  <div className="text-center">
                    <img src={fee} alt="" width="60" />
                    <h5 className="mt-3" style={{ color: "#484848" }}>Monthly Maintenance Fee</h5>
                    <p style={{ color: "#949292" }}>K50</p>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                  <div className="text-center">
                    <img src={hospital} alt="" width="60" />
                    <h5 className="mt-3" style={{ color: "#484848" }}>Hospital Cash Plan</h5>
                    <p style={{ color: "#949292" }}>K500/day for up to 10 days/year</p>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                  <div className="text-center">
                    <img src={shield} alt="" width="60" />
                    <h5 className="mt-3" style={{ color: "#484848" }}>Funeral Cover</h5>
                    <p style={{ color: "#949292" }}>For policyholder</p>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                  <div className="text-center">
                    <img src={loan} alt="" width="60" />
                    <h5 className="mt-3" style={{ color: "#484848" }}>Loan Access</h5>
                    <p style={{ color: "#949292" }}>Mid-month salary advances and personal loans</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Requirements Tab Content */}
        {activeTab === 'requirements' && (
          <section
            id="eligibility"
            class="eligibility-area tonse-savings-account"
            style={{ backgroundColor: "#FFF5E7" }}
          >
            <div className="container-fluid">
              <div className="sec-title text-center">
                <h2>Indo Salary A/C Required Documents</h2>
                <div className="sub-title">
                  <p>Basic documents required for opening a salary account.</p>
                </div>
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-xl-4 col-lg-6 mb-3">
                    <div
                      className="single-documents-box h-100 m-0"
                      style={{ backgroundColor: "#9E1B1E" }}
                    >
                      <div className="inner-title">
                        <h3 className="text-white">
                          IZB application form
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6 mb-3">
                    <div
                      className="single-documents-box h-100 m-0"
                      style={{ backgroundColor: "#9E1B1E" }}
                    >
                      <div className="inner-title">
                        <h3 className="text-white">Proof of residence</h3>
                      </div>
                      <ul>
                        <li>
                          <p className="text-white lh-base">
                            <AiFillCaretRight size={15} className="pe-1" />
                            Minimum of K1000 per month to be maintained
                          </p>
                        </li>
                        <li>
                          <p className="text-white lh-base">
                            <AiFillCaretRight size={15} className="pe-1" />
                            T-Pin
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6 mb-3">
                    <div
                      className="single-documents-box h-100 m-0"
                      style={{ backgroundColor: "#9E1B1E" }}
                    >
                      <div className="inner-title">
                        <h3 className="text-white">Copy of NRC/Passport</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6 mb-3">
                    <div
                      className="single-documents-box h-100 m-0"
                      style={{ backgroundColor: "#9E1B1E" }}
                    >
                      <div className="inner-title">
                        <h3 className="text-white">Recommendation letter</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6 mb-3">
                    <div
                      className="single-documents-box h-100 m-0"
                      style={{ backgroundColor: "#9E1B1E" }}
                    >
                      <div className="inner-title">
                        <h3 className="text-white">
                          Passport size photos
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Service Charges Tab Content */}
        {activeTab === 'charges' && (
          <section className="my-5">
            <div className="container">
              <div className="text-center my-5">
                <h2 style={{ color: "#484848" }}>
                  Service Charges
                </h2>
                <p style={{ color: "#949292" }}>
                  Service charges for Indo Salary Account
                </p>
              </div>
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  <div style={{ backgroundColor: "#FFF5E7", padding: "30px", borderRadius: "10px" }}>
                    <h4 style={{ color: "#9E1B1E" }}>Monthly Maintenance Fee</h4>
                    <p style={{ fontSize: "24px", fontWeight: "bold", color: "#484848" }}>K50.00</p>
                    <hr style={{ borderColor: "#9E1B1E", margin: "20px 0" }} />
                    <p style={{ color: "#949292" }}>
                      Additional charges may apply for other services such as ATM withdrawals, 
                      interbank transfers, and card replacements. Please contact our customer 
                      service for detailed fee information.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </section>

      <AllAccounts />
      <ContactForm />
      <CustomerCare />
      <OurStores />
    </>
  )
}

export default SalaryAccount
